"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/OrgsList/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _myRelations = require('shared/selectors/myRelations');

var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');
var _joinOrg = require('shared/hooks/org/joinOrg');
var _error = require('shared/services/error');
var _orgCreation = require('shared/services/orgCreation');
var _PageLayout = require('web/components/Settings/PageLayout'); var _PageLayout2 = _interopRequireDefault(_PageLayout);



var _OrgsList = require('web/components/Settings/OrgsList');







const OrgsListPage = ({
  memberOrgs,
  gotoOrg,
  gotoSettingsRoot,
}) => {
  const hasCurrentUserAnyTeams = _hooks.useAppSelector.call(void 0, _myRelations.selectHasCurrentUserAnyTeams)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const handleJoinOrCreateOrg = _react.useCallback.call(void 0, 
    (data) => _joinOrg.joinOrg.call(void 0, data)
      .then(org => {
        if (!org) return showSuccessBar('Requested to join organization')
        showSuccessBar(`Successfully created Organization: ${org.Name}`)
        gotoOrg(org.OrgKey)
      })
      .catch(err => {
        // A refusal by country or phone is final: say why and close the form.
        const orgCreationRefusal = _orgCreation.getOrgCreationRefusal.call(void 0, err)
        if (orgCreationRefusal) return showWarningBar(orgCreationRefusal)
        return _error.passError.call(void 0, () => showWarningBar(
          typeof data.org === 'string'
            ? 'Failed to create organization'
            : 'Failed to join organization',
        ))(err)
      }),
    [gotoOrg, showWarningBar, showSuccessBar],
  )

  return (
    _react2.default.createElement(_PageLayout2.default, { title: "Organizations", onBack: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      , _react2.default.createElement(_OrgsList.OrgsListSection, { orgsList: memberOrgs, gotoOrg: gotoOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}} )
      , _react2.default.createElement(_OrgsList.OrgsControlsSection, {
        onJoinOrCreateOrg: handleJoinOrCreateOrg,
        hasCurrentUserAnyTeams: hasCurrentUserAnyTeams, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, OrgsListPage)
